import { getRequest } from './api';

const adsAgeApi = {
  async getAdsAge(brandId) {
    if (!brandId) {
      throw new Error('brandId es requerido');
    }
    return getRequest(`/api/ads-age/${brandId}`);
  },
};

export default adsAgeApi;

